import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22loadFont.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./fonts/HakgyoansimDunggeunmisoR.ttf%22,%22style%22:%22normal%22,%22display%22:%22swap%22,%22weight%22:%2245%20920%22,%22variable%22:%22--font-hakgyoansim-dunggeunmiso-regular-variable%22}],%22variableName%22:%22hakgyoansimDunggeunmisoRegular%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'hakgyoansimDunggeunmisoRegular', 'hakgyoansimDunggeunmisoRegular Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
